import Vue from 'vue';
import Router from 'vue-router';
import Test from './views/Test/Test';
import MarqueeTest from './views/Test/Marquee';
import NotFound from './components/NotFound';
import DisplayManager from "./views/DisplayManager/DisplayManager";
import FakeDisplayManager from "./views/DisplayManager/FakeDisplayManager"


Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/preview',
            name: 'FakeDisplayManager',
            component: FakeDisplayManager
        },
        {
            path: '/test',
            name: 'Test',
            component: Test
        },
        {
            path: '/test/marquee',
            name: 'MarqueeTest',
            component: MarqueeTest
        },
        {
            path: '/',
            name: 'DisplayManager',
            component: DisplayManager
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound
        }
    ],
});


export default router;
